import React, { useEffect, useRef, useState } from "react";
import { API_BASE } from "../config";
import { documents as documentsImmo } from "../data/documents";
import { documents as documentsPma } from "../data/documentsPma";
import { documents as documentsMariage } from "../data/documentsMariage";
import { documents as documentsCertification} from "../data/documentsCertification";
import { documents as documentsDivorce} from "../data/documentsDivorce";
import { documents as documentsDonation} from "../data/documentsDonation";
import { documents as documentsBail} from "../data/documentsBail";
import { Dialog, DialogPanel, DialogBackdrop, DialogTitle } from '@headlessui/react';
import { ChevronDownIcon, DocumentIcon, CheckIcon, XMarkIcon } from "@heroicons/react/20/solid";
import Select from "react-select"

import { Field } from './catalyst/fieldset';
import { Textarea } from './catalyst/textarea';

function Drawer({ isOpen, onClose, id_affaire, type }) {
  const [documents, setDocuments] = useState([]);
  const [docDemande, setDocDemande] = useState(null);
  const [autreDocumentDemande, setAutreDocumentDemande] = useState(false);
  const [titreAutreDocDemande, SetTitreAutreDocDemande] = useState(null);
  const [messageSuccesDemandeDoc, setMessageSuccesDemandeDoc] = useState(false);
  const [messageErreurDemandeDoc, setMessageErreurDemandeDoc] = useState(false);
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState(null);
  const closeTimerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    };
  }, []);

  // Charger la bonne liste de documents quand `type` change
  useEffect(() => {
    if (type === "immo") {
      setDocuments(documentsImmo);
    } else if (type === "pma") {
      setDocuments(documentsPma);
    } else if (type === "mariage") {
      setDocuments(documentsMariage);
    } else if (type === "pacs") {
      setDocuments(documentsMariage);
    }else if (type === "certification") {
      setDocuments(documentsCertification);
    }else if (type === "donation") {
      setDocuments(documentsDonation);
    } else if (type === "divorce") {
      setDocuments(documentsDivorce);
    } else if (type === "bail") {
      setDocuments(documentsBail);
    }  else {
      setDocuments([]); // Réinitialisation si `type` est inconnu
    }
  }, [type]);

  const onChangeDocDemande = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue) {
      const [nom, destinataire] = selectedValue.split(" - ");
      setDocDemande({ nom, destinataire });
    }
  };

  const sendDemandeDocument = () => {
    fetch(`${API_BASE}/api/demande-document`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        docDemande,
        message,
        titreAutreDocDemande,
        transaction: id_affaire,
        type: type,
      }),
    })
      .then(() => {
        setMessageSuccesDemandeDoc(true);
        closeTimerRef.current = setTimeout(() => {
          onClose();
          setFile(null);
        }, 3000);
      })
      .catch(() => setMessageErreurDemandeDoc(true));
  };

  const groupedOptions = Object.entries(
  (documents || []).reduce((acc, doc) => {
    if (!acc[doc.destinataire]) acc[doc.destinataire] = [];
    acc[doc.destinataire].push({
      value: `${doc.nom} - ${doc.destinataire}`,
      label: doc.nom,
    });
    return acc;
  }, {})
).map(([label, options]) => ({ label, options }));

  return (

    <Dialog open={isOpen} onClose={onClose} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
      />
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
            <DialogPanel
              transition
              className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
            >
              <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                <div className="px-4 sm:px-6">
                  <div className="flex items-start justify-between">
                    <DialogTitle className="text-base font-semibold text-gray-900">Demander un document supplémentaire</DialogTitle>
                    <div className="ml-3 flex h-7 items-center">
                      <button
                        type="button"
                        onClick={onClose}
                        className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      >
                        <span className="absolute -inset-2.5" />
                        <span className="sr-only">Fermer</span>
                        <XMarkIcon aria-hidden="true" className="size-6" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="relative mt-6 flex-1 px-4 sm:px-6">
                  {messageSuccesDemandeDoc === true && <> <p className="text-sm font-bold text-emerald-600 mb-6"><CheckIcon className="size-6 inline-flex mr-3 text-emerald-600" />Votre demande de document a bien été enregistrée.</p></>}
                  {messageErreurDemandeDoc === true && <> <p className="text-sm font-bold text-red-600 mb-6"><XMarkIcon className="size-6 inline-flex mr-3 text-red-600" />Une erreur s'est produite, veuillez recommencer.</p></>}

                  <div className="rounded-md bg-slate-50 p-4 mb-3">
                    <div className="flex">
                      <div className="ml-3 flex-1 md:flex md:justify-between">
                        <p className="text-sm text-slate-700">Sélectionnez le document, et ajoutez si vous le souhaitez, un message à votre client, qui recevra votre demande de document par mail.</p>
                      </div>
                    </div>
                  </div>
                  {autreDocumentDemande === false &&
                    <>
                      <div className="mb-3">
                        <label className="mt-2 inline-flex gap-2 items-center font-bold" >Sélectionner un document</label>
                        <div className="mt-2 grid grid-cols-1">
                          <Select
                            options={groupedOptions}
                            placeholder="Sélectionnez votre fichier..."
                            // ✅ menu au-dessus de la modale + pas coupé
                            menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            menuPosition="fixed" // évite les soucis d'overflow/scroll
                            // ✅ valeur contrôlée
                            value={
                              docDemande?.nom
                                ? {
                                  value: `${docDemande.nom} - ${docDemande.destinataire}`,
                                  label: docDemande.nom,
                                }
                                : null
                            }
                            onChange={(selected) => {
                              if (!selected) {
                                setDocDemande(null);
                                return;
                              }
                              const [nom, destinataire] = selected.value.split(" - ");
                              setDocDemande({ nom, destinataire });
                            }}
                          />
                          {/* <select
                            className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                            onChange={onChangeDocDemande} value={docDemande.nom ? `${docDemande.nom} - ${docDemande.destinataire}` : ""} name="docdemande"> 
                          <option value="" disabled>
                              Sélectionnez votre fichier
                            </option>  */}

                          {/* Regroupement des documents par type */}
                          {/* {Object.entries(
                              documents.reduce((acc, document) => {
                                if (!acc[document.destinataire]) acc[document.destinataire] = [];
                                acc[document.destinataire].push(document);
                                return acc;
                              }, {})
                            ).map(([destinataire, docs]) => (
                              <optgroup key={destinataire} label={destinataire}>
                                {docs.map((document) => (
                                  <option key={document.nom} value={`${document.nom} - ${document.destinataire}`}>
                                    {document.nom}
                                  </option>
                                ))}
                              </optgroup>
                            ))} 
                          </select>  */}
                          <ChevronDownIcon
                            aria-hidden="true"
                            className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                          />
                        </div>
                      </div>
                      <a className="text-sm underline"
                        onClick={() => {
                          setAutreDocumentDemande(true);
                          setDocDemande(null);
                        }}>Autre document</a>
                    </>
                  }

                  {autreDocumentDemande === true &&
                    <>
                      <div className="mb-3">
                        <label className="mt-2 inline-flex gap-2 items-center font-bold"><DocumentIcon className="size-6  text-emerald-200" />Document demandé</label>
                        <input className="input-clotere" name="nomDocDemande" type="text" placeholder="Nom du document" required onChange={(e) => SetTitreAutreDocDemande(e.target.value)} />
                      </div>
                      <a className="text-sm underline"
                        onClick={() => {
                          setAutreDocumentDemande(false);
                          setDocDemande(null);
                        }}>Annuler</a>
                    </>
                  }

                  <div className="pb-3 mt-4">
                    <Field>
                      <label className="inline-flex gap-2 items-center font-bold">Accompagnez votre demande d'un message</label>
                      <Textarea rows="4" onChange={(e) => setMessage(e.target.value)} name="message" placeholder="Personnalisez le message de demande de document que recevra votre client." />
                    </Field>
                  </div>

                  <button onClick={() => { sendDemandeDocument() }} className="btn-primary">
                    Demander le document
                  </button>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </div>

    </Dialog>
  );
}

export default Drawer;